import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '../../../api/btlApplicationForm';
import { BtlAffordabilityRunResponse } from '../../../api/btlApplicationForm/types';

export const useRunAffordabilityCheck = (applicationId: string): UseQueryResult<BtlAffordabilityRunResponse> =>
  useQuery(
    ['btl-application-run-affordability-check', applicationId],
    () => btlApplicationFormApi.runAffordabilityCheck(applicationId),
    {
      enabled: false,
    },
  );
